import { Flex, TableRowSelectionProvider } from '@/components';
import type { FC } from 'react';
import { Navigate, useLocation } from 'react-router';
import { CommentListSearchAccordion } from '../components/list/search';
import { CommentListTable } from '../components/list/table';
import { useLastCommentSearchHistory } from '../hooks/local-storage';
import CommentLayout from '../layouts/CommentLayout';

const CommentListPage: FC = () => {
  const location = useLocation();
  const { commentPathWithQuery } = useLastCommentSearchHistory();
  const hasSearchParams = location.search !== '';

  // 検索パラメータがなく、かつ前回の検索条件が存在する場合は前回の検索条件を使用する
  const queryString = commentPathWithQuery.split('?')[1];
  if (!hasSearchParams && queryString) {
    return <Navigate to={`?${queryString}`} replace />;
  }
  return (
    <TableRowSelectionProvider>
      <CommentLayout>
        <Flex vertical gap="middle">
          <CommentListSearchAccordion />
          <CommentListTable />
        </Flex>
      </CommentLayout>
    </TableRowSelectionProvider>
  );
};

export default CommentListPage;
